import { forwardRef } from 'react';
/**
 * Является React.forwardRef, но добавляет возможность использовать с generic компонентами.
 *
 * @example
 * ```typescript
 * import { genericForwardRef } from '@direct-frontend/stdlib';
 *
 * interface ForwardedRefGenericComponentProps<SomeType> {
 *     field: SomeType;
 * }
 *
 * // ForwardedRefGenericComponent будет иметь generic пропсы ForwardedRefGenericComponentProps<SomeType>
 * const ForwardedRefGenericComponent = genericForwardRef(
 *   <SomeType>(props: ForwardedRefGenericComponentProps<SomeType>, ref: React.ForwardedRef<HTMLLIElement>) => {
 *       return ...;
 *   }
 * );
 * ```
 *
 * @returns React.Component
 */
export const genericForwardRef = forwardRef;
